import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './button';
import { LogOut, Home } from 'lucide-react';

/**
 * Header compartido para todas las páginas de administración
 * Mantiene consistencia visual y funcionalidad
 */
const AdminHeader = ({ 
  adminData, 
  onLogout, 
  showBackButton = false, 
  onBackClick,
  backButtonText = "Volver",
  showDashboardButton = false
}) => {
  const navigate = useNavigate();

  return (
    <header className="bg-white shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center gap-4">
            {showBackButton && (
              <Button
                onClick={onBackClick}
                variant="outline"
                size="sm"
                className="flex items-center gap-2"
              >
                ← {backButtonText}
              </Button>
            )}
            {showDashboardButton && (
              <Button
                onClick={() => navigate('/admin')}
                variant="outline"
                size="sm"
                className="flex items-center gap-2"
              >
                <Home className="w-4 h-4" />
                Dashboard
              </Button>
            )}
          </div>
          <div className="flex items-center space-x-4">
            <div className="flex items-center gap-2">
              <span className="text-sm text-gray-600">
                {adminData?.name} {adminData?.lastName}
              </span>
            </div>
            <Button
              onClick={onLogout}
              variant="outline"
              size="sm"
              className="flex items-center gap-2"
            >
              <LogOut className="w-4 h-4" />
              Cerrar Sesión
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader; 